import React, { useEffect, useState } from "react";

export const PrivacyPolicy = ({isLight}) => {
  const [show, setShow] = useState({ show1: false, show2: false, show3: false });

   useEffect(() => {
    const t1 = setTimeout(() => setShow(s => ({ ...s, show1: true })), 200);
    const t2 = setTimeout(() => setShow(s => ({ ...s, show2: true })), 600);
    const t3 = setTimeout(() => setShow(s => ({ ...s, show3: true })), 1000);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);


  const textColor = isLight ? 'text-slate-900' : 'text-white';
  const subTextColor = isLight ? 'text-slate-600' : 'text-white/80';
  const metaTextColor = isLight ? 'text-slate-500' : 'text-white/70';
  const borderColor = isLight ? 'border-slate-200' : 'border-white/10';
  const dividerColor = isLight ? 'bg-cyan-500/20' : 'bg-cyan-300/40';
  
  return (
    <div className={`rounded-lg p-8 md:p-12 border animate-in backdrop-blur-md transition-all duration-500 shadow-2xl ${
      isLight ? 'bg-white/80 border-slate-200' : 'bg-[#111114]/80 border-white/10'
    }`}>
      <div className="relative z-10 flex flex-col items-center">
        
        {/* Section 1: Introduction */}
        <section className={`max-w-2xl w-full text-center transition-all duration-700 ${show.show1 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className={`text-[20px] font-black mb-8 uppercase tracking-[0.2em] border-b pb-4 ${isLight ? 'border-slate-100' : 'border-white/5'} ${textColor}`}>
            Privacy Policy
          </h2>
          <p className={`uppercase text-[12px] font-normal mb-6 tracking-widest ${metaTextColor}`}>
            Last Updated : Aug 16 2025
          </p>
          <p className={`mb-8 text-lg text-justify leading-relaxed ${textColor}`}>
            Lucy is a simple and smart way to detect fraudulent URLs. We care about your privacy and the security of your personal information.
          </p>
        </section>

        <div className="w-full flex justify-center">
          <div className={`h-1 w-2/3 rounded-3xl my-4 shadow-sm ${dividerColor}`} />
        </div>

        {/* Section 2: Policy Details */}
        <section className={`max-w-2xl w-full mx-auto transition-all duration-700 ${show.show2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="space-y-12 py-6">
            <div>
              <h3 className={`text-lg md:text-xl font-black mb-4 tracking-wide uppercase text-left ${textColor}`}>Information We Collect</h3>
              <div className={`text-base text-justify leading-relaxed space-y-4 ${subTextColor}`}>
                <p>Lucy does not collect, store, or share any personally identifiable information.</p>
                <div className={`p-4 border-l-2 ${isLight ? 'border-cyan-500 bg-cyan-50/50' : 'border-cyan-400 bg-cyan-400/5'}`}>
                  <p>Lucy may ask for permission to “send and view SMS messages”, if allowed: Lucy may access your device’s messages locally to identify links. Only the links are extracted for phishing analysis. Message contents are never transmitted, stored, or shared.</p>
                </div>
              </div>
            </div>

            <div>
              <h3 className={`text-lg md:text-xl font-black mb-4 tracking-wide uppercase text-left ${textColor}`}>How We Use Information</h3>
              <div className={`text-base text-left ${subTextColor}`}>
                <p className="mb-4">The links you provide are used only for phishing detection. Lucy does not:</p>
                <ul className="list-none space-y-2 ml-2">
                  <li className="flex items-center gap-3">
                    <span className="w-1.5 h-1.5 rounded-3xl bg-cyan-500"></span>
                    Collect or store your personal data
                  </li>
                  <li className="flex items-center gap-3">
                    <span className="w-1.5 h-1.5 rounded-3xl bg-cyan-500"></span>
                    Share your data with third parties
                  </li>
                  <li className="flex items-center gap-3">
                    <span className="w-1.5 h-1.5 rounded-3xl bg-cyan-500"></span>
                    Use your data for marketing, advertising, or analytics
                  </li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className={`text-lg md:text-xl font-black mb-4 tracking-wide uppercase text-left ${textColor}`}>Data Storage and Security</h3>
              <div className={`text-base text-left leading-relaxed ${subTextColor}`}>
                Lucy does not maintain any database of user information. All link analysis results are stored on a local database on the user’s device. No data is transmitted to external servers.
              </div>
            </div>

            <div>
              <h3 className={`text-lg md:text-xl font-black mb-4 tracking-wide uppercase text-left ${textColor}`}>Third-Party Services</h3>
              <div className={`text-base text-left ${subTextColor}`}>
                Lucy shares the domain of the URL provided with <a href="https://www.domcop.com/openpagerank/what-is-openpagerank" className="text-cyan-500 hover:text-cyan-400 underline underline-offset-4 transition-all" target="_blank" rel="noopener noreferrer">Page Rank Checker</a> to obtain data on the page rank and reputation of the website.
              </div>
            </div>

            <div>
              <h3 className={`text-lg md:text-xl font-black mb-4 tracking-wide uppercase text-left ${textColor}`}>Children’s Privacy</h3>
              <div className={`text-base text-left ${subTextColor}`}>
                Lucy is not directed to children under the age of 13. We do not collect any personal information from children.
              </div>
            </div>

            <div>
              <h3 className={`text-lg md:text-xl font-black mb-4 tracking-wide uppercase text-left ${textColor}`}>Changes to This Privacy Policy</h3>
              <div className={`text-base text-left ${subTextColor}`}>
                We may update this Privacy Policy from time to time. Updates will be posted on our official website. Please check this page periodically for any changes.
              </div>
            </div>

            <div>
              <h3 className={`text-lg md:text-xl font-black mb-4 tracking-wide uppercase text-left ${textColor}`}>Contact Us</h3>
              <div className={`text-base text-left ${subTextColor}`}>
                If you have any questions or concerns about this Privacy Policy or Lucy’s data practices, please contact us at: <a href="mailto:0xdagcorp@gmail.com" className={`underline underline-offset-4 hover:text-cyan-500 transition-colors ${subTextColor}`}>0xdagcorp@gmail.com</a>
              </div>
            </div>
          </div>
        </section>

        <div className="w-full flex justify-center">
          <div className={`h-px w-2/3 my-6 ${dividerColor}`} />
        </div>

        {/* Section 3: Closing Statement */}
        <section className={`max-w-2xl w-full text-center transition-all duration-700 ${show.show3 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className={`italic font-black text-base uppercase tracking-widest ${metaTextColor}`}>
            Your privacy and security matter to us.
          </span>
        </section>
      </div>
    </div>
  );
}
